define('SageDotCom/Components/AlertService',['jquery'], function($) {

    function AlertService(scope) {
        $('.alert-service-form', scope).on('submit', function() {
            var checkboxes = $(this).closest('form').find(':checkbox');
            var interests = [];
            checkboxes.each(function () {
                if ($(this).is(":checked") && $(this).attr('name') != 'Agreement') {
                    var interest = { Id: $(this).data("id"), Name: $(this).data("name"), IsRns: $(this).data("rns") }
                    interests.push(interest);
                }
            });
            if (interests.length > 0) {
                $("#Interests", scope).val(JSON.stringify(interests));
            }

            urlEncodeInput("#Name", scope);
            urlEncodeInput("#Email", scope);
            urlEncodeInput("#UpdateEmail", scope);
        });

        $('.select-all', scope).on('click', function () {
            $(this).closest('.subsection').find(':checkbox').prop('checked', true);
        });

        $('.deselect-all', scope).on('click', function () {
            $(this).closest('.subsection').find(':checkbox').prop('checked', false);
        });
    }

    function urlEncodeInput(elemId, scope) {
        var inputvalue = $(elemId, scope).val();
        if (inputvalue !== "") {
            inputvalue = inputvalue.replace(/<\/?[^>]+(>|$)/g, "");
            $(elemId, scope).val(inputvalue);
        }
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new AlertService(args.scope);
    }
});
